$(document).ready(function () {
  const MINIMUM_PRICE = 164.95;
  const targetInput = 'input[name="Type"]';
  const targetRechargeWidget = ".recharge-subscription-widget";
  
  let updateBuildABoxInterval;
  let initBuildABoxInterval;
  
  let updateBuildABoxPortalInterval;
  let initBuildABoxPortalInterval;

  const checkIfBuildABox = () => {
    return (
      window.location.pathname === "/products/build-a-box" ||
      window.location.pathname === "/products/build-a-box-subscription"
    );
  };

  const checkIfBuildABoxRechargePortal = () => {
    return (
      window.location.pathname.includes("/tools/recurring/portal/")
    );
  };
  
  const checkIfReady = () => {
    const els = document.querySelectorAll(".rb-portal-heading");

    return els.length > 0;
  };

  const checkIfPortalReady = () => {
    const els = document.querySelectorAll("#build-a-box .rb-portal-body .thl-copy span");

    return els.length > 0;
  };

  const canAddToCart = () => {
    const currentPriceRaw = document.querySelector(
      ".rb-header .rb-price span"
    )?.innerHTML;

    if (!currentPriceRaw) {
      return false;
    }

    const currentPrice = parseFloat(currentPriceRaw.replace(/[^\d.-]/g, ""));

    return currentPrice >= MINIMUM_PRICE;
  };

  const updateBottomBar = () => {
    const el = document.querySelector(".rb-portal-heading");
    el.innerHTML = `Choose products until it reaches a minimum of $${Number(MINIMUM_PRICE).toFixed(2)}`;
  };

  const updateAddToCartButton = () => {
    const isButtonDisabled = !canAddToCart();
    const buttons = document.querySelectorAll(".rb-form .rb-btn");

    buttons.forEach((button) => {
      button.disabled = isButtonDisabled;
    });
  };

  const prepareInterval = () => {
    updateBuildABoxInterval = setInterval(() => {
      updateAddToCartButton();
    }, 250);
  };
  
  const validateBuildABoxRechargeSubscription = () => {
    if (!document.querySelector("#build-a-box .rb-portal-body .thl-copy span")) {
      return;
    }

    // Ensure that this is a build a box product
    const productTitle = document.querySelector('.recharge-heading-h1')?.innerHTML ?? null;
    if (!productTitle || !productTitle.toLowerCase().includes('build a box')) {
      return;
    }
    
    // Get the value of the cart
    const cartValue = document.querySelector(
      "#build-a-box .rb-portal-body .thl-copy span"
    ).innerHTML;

    // Extract numeric value from the cart string and remove non-numeric characters except dot
    const numericValue = parseFloat(cartValue.replace(/[^\d.]/g, ""));

    // Check if the numeric value is greater than or equal to 150
    if (numericValue >= MINIMUM_PRICE) {
      // Remove 'tdisabled' class from button
      document.querySelector("#build-a-box [can-save=true] .rb-subs-nav-btn")?.classList.remove("tdisabled");
    } else {
      // Add 'tdisabled' class to button
      document.querySelector("#build-a-box [can-save=true] .rb-subs-nav-btn")?.classList.add("tdisabled");
    }
  };
  
  const preparePortalInterval = () => {
    updateBuildABoxPortalInterval = setInterval(() => {
      validateBuildABoxRechargeSubscription();
    }, 250);
  };

  const initBuildABox = () => {
    if (checkIfBuildABox()) {
      initBuildABoxInterval = setInterval(() => {
        if (checkIfReady()) {
          updateBottomBar();
          prepareInterval();
          clearInterval(initBuildABoxInterval);
        }
      }, 1000);
    } 
  };

  const initBuildABoxPortal = () => {
    if (checkIfBuildABoxRechargePortal()) {
      initBuildABoxPortalInterval = setInterval(() => {
        if (checkIfPortalReady()) {
          preparePortalInterval();
          clearInterval(initBuildABoxPortalInterval);
        }
      }, 1000);
    }
  };

  initBuildABox();
  initBuildABoxPortal();
});
